import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { CheckSquare, BookOpen, History, Sun, Moon, Plus } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

const BottomNav = () => {
  const location = useLocation();
  const { theme, toggleTheme } = useTheme();

  const isActive = (path) => {
    if (path === '/') {
      return location.pathname === '/' || location.pathname === '/weekly';
    }
    return location.pathname === path;
  };

  return (
    <nav className="bottom-nav">
      <Link to="/" className={`nav-item ${isActive('/') ? 'active' : ''}`}>
        <CheckSquare size={20} strokeWidth={2} />
        <span className="nav-label">Today</span>
      </Link>
      <Link to="/subjects" className={`nav-item ${isActive('/subjects') ? 'active' : ''}`}>
        <BookOpen size={20} strokeWidth={2} />
        <span className="nav-label">Subjects</span>
      </Link>
      <div className="fab-container">
        <Link to="/add-task" className="fab">
          <Plus size={24} strokeWidth={3} />
        </Link>
      </div>
      <Link to="/history" className={`nav-item ${isActive('/history') ? 'active' : ''}`}>
        <History size={20} strokeWidth={2} />
        <span className="nav-label">History</span>
      </Link>
      <button
        onClick={toggleTheme}
        className="nav-item theme-toggle"
        aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
      >
        {theme === 'light' ? (
          <Moon size={20} strokeWidth={2} />
        ) : (
          <Sun size={20} strokeWidth={2} />
        )}
        <span className="nav-label">Theme</span>
      </button>
    </nav>
  );
};

export default BottomNav;
